<template>
  <div class="alerts-page">
    <back-button data-vue-link class="back-button"/>

    <alerts-container header="Click & Collect">

      <alert-list type="cc" status="pending" slot="left" :alerts="alerts" />
      <alert-list type="cc" status="complete" slot="right" :alerts="alerts"/>

    </alerts-container>

    <alerts-container header="Pay My Bill" >

      <alert-list type="pmb" status="pending" slot="left" :alerts="alerts"/>
      <alert-list type="pmb" status="complete" slot="right" :alerts="alerts"/>
    
    </alerts-container>

    <alerts-container header="Drinks At Table" data-bottom>

      <alert-list type="d" status="pending" slot="left" :alerts="alerts"/>
      <alert-list type="d" status="complete" slot="right" :alerts="alerts"/>
    
    </alerts-container>

    <alerts-container header="Order Ahead" data-bottom>

      <alert-list type="oa" status="pending" slot="left" :alerts="alerts"/>
      <alert-list type="oa" status="complete" slot="right" :alerts="alerts"/>
    
    </alerts-container>

  </div>
</template>

<script>
import AWS                from 'aws-sdk/global'
import AWSMqtt            from 'aws-mqtt'
import BackButton         from '@/components/ui/BackButton'
import AlertsContainer    from '@/components/ui/AlertsContainer'
import AlertList          from '@/components/alerts/containers/AlertList'
import { mapState }       from 'vuex'

export default {
  name: 'AlertsPage',

  components: {
    BackButton,
    AlertsContainer,
    AlertList
  },
  computed: mapState({
    alerts: state => state.alerts.alerts,
    restId: state => state.alerts.restId,
    stage:  state => {
      if (process.env.NODE_ENV === 'production') return 'prod'
      return 'stage'
    }
  }),
  data () {
    return {
      mqttClient: null
    }
  },

  methods: {
    subscribe () {
      window.trg.mqttStatus   = 'connected'
      window.trg.subscribeUrl = `/trg-alerts/${ this.stage }/${ this.restId }/alert`
      window.trg.restId       = this.restId 
      window.trg.env          = process.env.NODE_ENV

      this.mqttClient.subscribe(window.trg.subscribeUrl)
    },
    handleAlert (topic, message) {
      const newAlert = JSON.parse(message.toString('utf8'))
      this.$store.dispatch('alerts/addAlert', { newAlert })
      this.launchToast(newAlert)
    },
    launchToast (newAlert) {
      if (newAlert.type == 'cc') {
        const date = this.$moment(newAlert.cc_timeslot).format('hh:mm') 
        this.$toasted.show(`New Order! ${date}`, { icon: 'car', className: "cc-alert-toast" }) 

      } else if (newAlert.type == 'pmb') {
        this.$toasted.show(`New Payment! #${newAlert.table_number}`, { icon: 'credit-card', className: "pmb-alert-toast"}) 

      } else if (newAlert.type == 'pmb') {
        this.$toasted.show(`New Drinks Order! #${newAlert.table_number}`, { className: "d-alert-toast"}) 

      } else if (newAlert.type == 'oa') {
        this.$toasted.show(`New Pre Order!`, { className: "d-alert-toast"}) 
      }
    }
  },

  created () {

    const connectionParams = {
      WebSocket: window.WebSocket, 
      region: AWS.config.region,
      credentials: AWS.config.credentials,
      endpoint: 'a9ku16lj5d4zx-ats.iot.us-east-1.amazonaws.com',

      clientId: 'mqtt-client-' + (Math.floor((Math.random() * 100000) + 1)), // clientId to register with MQTT broker. Need to be unique per client
    }
    this.mqttClient = AWSMqtt.connect(connectionParams)

    this.mqttClient
      .on('connect', this.subscribe)
      .on('message', this.handleAlert)
      .on('close', () => {
        window.trg.mqttStatus = 'closed'
        console.log('MQTT Connlection Closed')
      })
    this.$store.dispatch('alerts/getAllertsForSite', { restId: this.restId })
  }, 

  beforeDestroy () {
    this.mqttClient.end()
  }

}
</script>

<style lang="scss" scoped>
  .alerts-page {
    .back-button {
      position: absolute;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/AlertsPage.vue